var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "url(#paint0_linear_198_1840)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_1840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9875 16.704C27.95 15.8539 27.8125 15.2694 27.6156 14.763C27.4124 14.2254 27.0998 13.7441 26.6903 13.344C26.2902 12.9377 25.8058 12.6219 25.2744 12.422C24.765 12.225 24.1836 12.0875 23.3335 12.0501C22.477 12.0094 22.2051 12 20.0328 12C17.8605 12 17.5886 12.0094 16.7353 12.0469C15.8851 12.0844 15.3007 12.222 14.7944 12.4188C14.2567 12.6219 13.7754 12.9345 13.3753 13.344C12.9689 13.7441 12.6533 14.2286 12.4532 14.7599C12.2563 15.2694 12.1188 15.8507 12.0813 16.7009C12.0407 17.5574 12.0312 17.8293 12.0312 20.0016C12.0312 22.1739 12.0407 22.4458 12.0781 23.2991C12.1156 24.1492 12.2532 24.7337 12.4502 25.2401C12.6533 25.7777 12.9689 26.259 13.3753 26.6591C13.7754 27.0654 14.2598 27.3812 14.7912 27.5812C15.3007 27.7781 15.882 27.9156 16.7322 27.9531C17.5854 27.9907 17.8575 28 20.0298 28C22.202 28 22.474 27.9907 23.3273 27.9531C24.1774 27.9156 24.7619 27.7781 25.2682 27.5812C26.3435 27.1654 27.1936 26.3153 27.6093 25.2401C27.8062 24.7306 27.9438 24.1492 27.9812 23.2991C28.0187 22.4458 28.0281 22.1739 28.0281 20.0016C28.0281 17.8293 28.025 17.5574 27.9875 16.704ZM26.5466 23.2366C26.5122 24.018 26.381 24.4399 26.2716 24.7212C26.0027 25.4183 25.4495 25.9715 24.7525 26.2403C24.4712 26.3497 24.0462 26.481 23.2678 26.5153C22.4239 26.5529 22.1708 26.5622 20.036 26.5622C17.9012 26.5622 17.6449 26.5529 16.804 26.5153C16.0226 26.481 15.6007 26.3497 15.3194 26.2403C14.9725 26.1121 14.6568 25.909 14.4005 25.6433C14.1348 25.3838 13.9316 25.0713 13.8034 24.7244C13.694 24.4431 13.5628 24.018 13.5285 23.2397C13.4909 22.3958 13.4816 22.1426 13.4816 20.0078C13.4816 17.873 13.4909 17.6167 13.5285 16.776C13.5628 15.9946 13.694 15.5726 13.8034 15.2913C13.9316 14.9443 14.1348 14.6287 14.4037 14.3723C14.663 14.1066 14.9755 13.9034 15.3225 13.7754C15.6038 13.666 16.029 13.5347 16.8072 13.5003C17.6511 13.4628 17.9043 13.4534 20.039 13.4534C22.177 13.4534 22.4301 13.4628 23.271 13.5003C24.0524 13.5347 24.4743 13.666 24.7556 13.7754C25.1025 13.9034 25.4182 14.1066 25.6745 14.3723C25.9402 14.6317 26.1434 14.9443 26.2716 15.2913C26.381 15.5726 26.5122 15.9976 26.5466 16.776C26.5841 17.6199 26.5935 17.873 26.5935 20.0078C26.5935 22.1426 26.5841 22.3927 26.5466 23.2366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0321 15.8916C17.7629 15.8916 15.9219 17.7325 15.9219 20.0018C15.9219 22.271 17.7629 24.112 20.0321 24.112C22.3013 24.112 24.1422 22.271 24.1422 20.0018C24.1422 17.7325 22.3013 15.8916 20.0321 15.8916ZM20.0321 22.6679C18.56 22.6679 17.3659 21.474 17.3659 20.0018C17.3659 18.5296 18.56 17.3356 20.0321 17.3356C21.5043 17.3356 22.6982 18.5296 22.6982 20.0018C22.6982 21.474 21.5043 22.6679 20.0321 22.6679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.263 15.7291C25.263 16.259 24.8333 16.6886 24.3033 16.6886C23.7734 16.6886 23.3438 16.259 23.3438 15.7291C23.3438 15.1991 23.7734 14.7695 24.3033 14.7695C24.8333 14.7695 25.263 15.1991 25.263 15.7291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_1840",
    x1: 5.85929,
    y1: 34.1445,
    x2: 34.1407,
    y2: 5.85929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns);
export default __webpack_public_path__ + "static/media/ins.99a35c568f5bfca738b7b73dac8c8c53.svg";
export { ForwardRef as ReactComponent };